import { ref } from "vue";

const consultant = ref({
    id: "",
    type: "",
    active: false,
    houseStyle: "",
});

export default consultant;